<cart>
    <div ref="overlay" onclick="{toggleCart}" class="aero-overlay d-none close-cart"></div>

    <div ref="cartContainer" class="container pl-4 pr-4 aeroviewer-side-cart close">
        <div class="row">
            <div class="col-6">
                <h3 class="">My Cart</h3>
            </div>
            <div class="col-6 text-right pt-3">
                <i id="close-cart" onclick="{toggleCart}" class="fa fa-close close-cart"></i>
            </div>
        </div>
        <hr>
        <div class="row aeroviewer-scrollable">
            <div each="{item in opts.items}" class="col-12 mt-2 mb-2">
                <!--  Cart Item Title   -->
                <p if="{isContent(item)}" class="aeroviewer-element-container-sub">
                    {item.category} / {item.specs}
                </p>
                <p if="{isOffer(item)}" class="aeroviewer-element-container-sub">
                    {item.content.name} - Bundle / {item.specs}
                </p>
                <p if="{isPlan(item)}" class="aeroviewer-element-container-sub">
                    DigiShare™ Service Subscription
                </p>

                <!--    Cart Item type     -->
                <img if="{isPhoto(item)}" src="{getPreview(item)}" class="img-fluid" style="width: 100% !important;"
                     alt="{item.content.name}">
                <img if="{isFootage(item)}" src="{getPreview(item)}" class="img-fluid" style="width: 100% !important;"
                     alt="{item.content.name}">
                <img if="{isCollection(item)}" src="{getPreview(item)}" class="img-fluid"
                     style="width: 100% !important;" alt="{item.content.name}">
                <img if="{isRecording(item)}" src="{window.backend + item.content.thumbnail.replace('/collections/', '')}" class="img-fluid"
                     style="width: 100% !important;" alt="{item.content.name}">
                <div if="{isOffer(item)}" class="img-thumbnail img-responsive text-center"
                     style="background-color: #48b0f7 !important; padding-top: 20.125%; padding-bottom: 20.125%;">
                    <i class="fa fa-gift fa-5x text-white"></i>
                </div>
                <div if="{isPlan(item)}" class="img-thumbnail img-responsive text-center"
                     style="background-color: #10cfbd !important; padding-top: 20.125%; padding-bottom: 20.125%;">
                    <i class="fa fa-desktop fa-5x text-white"></i>
                </div>

                <a id="cart-remove-item" href="" onclick="{onCartItemRemove}">
                    <i class="fa fa-trash aero-img-trash-btn fa-2x"></i>
                </a>
            </div>

        </div>
        <div class="aeroviewer-side-cart-footer">
            <hr>
            <div class="row">
                <div class="col-12 text-center">
                    <p>Items in Cart: {opts.total}</p>
                    <p>Total: {opts.price} €</p>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-12">
                    <button id="cart-checkout" onclick="{onCheckout}" class="btn aero-btn-primary btn-lg w-100">
                        Checkout
                    </button>
                </div>
            </div>
        </div>
    </div>

    <script>

        // import utils

        import {uriCompile} from "../../utils.es6";

        const tag = this;

        //methods
        tag.toggleCart = (event) => {

            if (event) {
                event.preventUpdate = true;
                event.preventDefault();
            }

            tag.cartContainer.classList.toggle('close');
            tag.cartContainer.classList.toggle('open');
            tag.overlay.classList.toggle('d-none')
        };

        tag.isRecording = (item) => {
            // ugly hack to determine is video is recording
            // for compatibility reasons with dashboard

            return !!(item.content.video_id) && (item.category === 'video');
        };

        tag.isFootage = (item) => {
            // ugly hack to determine is video is recording
            // for compatibility reasons with dashboard

            return (!item.content.video_id) && (item.category === 'video');
        };

        tag.isContent = (item) => {
            return item.category !== 'plan' && item.category !== 'offer'
        };

        tag.isPhoto = (item) => {
            // ugly hack to determine is video is recording
            // for compatibility reasons with dashboard

            return item.category === 'photo';
        };

        tag.isPlan = (item) => {
            // ugly hack to determine is video is recording
            // for compatibility reasons with dashboard

            return item.category === 'plan';
        };

        tag.isCollection = (item) => {
            // ugly hack to determine is video is recording
            // for compatibility reasons with dashboard

            return item.category === 'collection';
        };

        tag.isMedia = (item) => {
            return item.content.type === 'video' ||
                item.content.type === 'photo' ||
                item.content.type === 'collection';
        };

        tag.isOffer = (item) => {
            return item.category === 'offer'
        };

        tag.getPreview = (item) => {
            // Get Cart preview for non recording items
            return !!(item.content.thumbnail) ? item.content.thumbnail.replace('/collections/', '') : uriCompile(item.content.preview_url, 'WW_TSS')
        };

        // Event action handling
        tag.onCheckout = (event) => {
            if (event) {
                event.preventUpdate = true;
                event.preventDefault();
            }

            window.location.href = '/checkout'
        };

        tag.onCartItemRemove = (event) => {
            if (event) {
                event.preventUpdate = true;
                event.preventDefault();
            }

            return opts.service.removeItem(event.item.item);
        };

        // lifecycle events
        tag.on('mount', () => {
            tag.overlay = tag.refs.overlay;
            tag.cartContainer = tag.refs.cartContainer;

        });
    </script>

</cart>


// WEBPACK FOOTER //
// avr_eshop/frontend/components/nav-bar/cart.tag.html